<!--SKU编辑  -->
<template>
	<div class="dialogBox">
		<el-dialog title="客商信息" v-if="dialogVisible" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="800px" :before-close="cancle">
			<span slot="title" class="flex flex-middle">
				<div class="title">添加客商</div>
				<div class="flex ml15">
					<el-input v-model.trim="agentName" class="w190" size="small" placeholder="客商名称" maxlength="16"
						clearable>
					</el-input>
					<img class="icon-img ml10" src="@/assets/images/search.png" @click="handleSearch" alt="">
				</div>
			</span>
			<div class="form-box" v-if="newFlag=='Y'">
				<el-table class="" ref="multipleTable" :row-key="(row)=>{ return row.agentId}" :data="tableData"
					v-el-table-infinite-scroll="tableLoad" height="300" @selection-change="handleSelectionChange"
					@row-click="handleRowClick1"
					:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}" border
					style="width: 100%">
					<el-table-column type="selection" :reserve-selection="true" width="55">
					</el-table-column>
					<el-table-column prop="agentCode" label="客商编号">
					</el-table-column>
					<el-table-column prop="agentName" label="客商名称">
					</el-table-column>
					<el-table-column prop="settlementType" label="结算方式">
						<template slot-scope="scope">
							{{settlementType[scope.row.settlementType]}}
						</template>
					</el-table-column>
				</el-table>

			</div>
			<div v-else>
				<el-table class="mt10" ref="multipleTable" :row-key="(row)=>{ return row.agentId}" v-el-table-infinite-scroll="tableLoad" :data="tableData"
					height="300" :header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}"
					@row-click="handleRowClick"  border style="width: 100%">
					<el-table-column width="70" label="选择" align="center">
						<template slot-scope="scope">
							<el-radio v-model="selecteId" :label="scope.row.agentId" @change="radioRow(scope.row)">
							</el-radio>
						</template>
					</el-table-column>
					<el-table-column prop="agentCode" label="客商编号">
					</el-table-column>
					<el-table-column prop="agentName" label="客商名称">
					</el-table-column>
					<el-table-column prop="settlementType" label="结算方式">
						<template slot-scope="scope">
							{{settlementType[scope.row.settlementType]}}
						</template>
					</el-table-column>
				</el-table>
			</div>
			<span slot="footer" class="dialog-footer mt10">
				<el-button  size="small" @click="cancle()">取 消</el-button>
				<el-button  size="small" type="primary" @click="submitForm()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		debounce
	} from '@/utils/debounce'
	export default {
		data() {
			return {
				dialogVisible: false,
				agentName: "",
				tableData: [],
				pageNo: 1,
				pageSize: 10,
				totalPage: 0,
				multipleSelection: [],
				multipleSelection1: [],
				settlementType: {
					0: '现金',
					1: '账期',
					2: '其它',
					9: '自贩'
				},
				newFlag: "",
				selecteId: '',
				selectList: [],
				infiniteFlag: false,
			}
		},
		created() {

		},
		methods: {
			init(selectList, newFlag) {
				this.$nextTick(() => {
					this.dialogVisible = true
					this.infiniteFlag=false
					this.newFlag = newFlag
					this.pageNo = 1
					this.agentName = ''
					this.multipleSelection=[]
					this.getAgentList()
					this.selecteId = ""
					this.selectList = selectList

				})
			},

			//  获取列表
			getAgentList(type) {
				if(this.infiniteFlag) {
					return
				}
				let that = this;
				that.$request.post(
						"agentList",
						true, {
							pageNo: that.pageNo,
							pageSize: that.pageSize,
							agentName: that.agentName,
							newFlag: that.newFlag,
							ncSealflag:that.newFlag=="N"?1:"",
							settlementType: '9'
						}
					)
					.then((res) => {
						if(res.data) {
							that.infiniteFlag = res.data.totalPage <= that.pageNo;
							}
						if (type == 'scroll') {
							that.tableData = that.tableData.concat(res.data && res.data.list || []);
						} else {
							if (res.data && res) {
								that.tableData = res.data.list
							} else {
								that.tableData = []
							}
						}

					})
			},
			// 表格滚动加载
			tableLoad: debounce(function () {
				this.pageNo++;
				this.getAgentList('scroll');
			}, 100, true),
			// 当前页切换
			handleCurrentChange(val) {
				this.pageNo = val;
				this.getAgentList();
			},
			// 搜索
			handleSearch() {

				this.pageNo = 1;
				this.infiniteFlag = false;
				this.getAgentList();
				if (this.tableData.length > 0) {
					this.$refs.multipleTable.clearSelection();
					this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
				}
			},
			// 列多选
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			handleSelectionChange1(val) {
				this.multipleSelection1 = val;
			},
			// 列单选
			radioRow(val) {
				this.multipleSelection = [];
				this.multipleSelection.push(val)
			},
			// 点击行选中
			handleRowClick1(row, column, event) {
				this.$refs.multipleTable.toggleRowSelection(row);
			},
			// 点击行选中
			handleRowClick(row, column, event) {
				this.selecteId = row.agentId;
				this.multipleSelection = [];
				this.multipleSelection.push(row)
			},
			// 保存
			submitForm: debounce(function () {
				let newArr=[]
				// 源客商
				if(this.newFlag=="Y"){
					let agentIds = []
					this.selectList.forEach(item => {
						agentIds.push(item.agentId)
					});
					let repeat = false
					this.multipleSelection.some(item => {
						if(agentIds.includes(item.agentId)){
							repeat = true
							return agentIds.includes(item.agentId) // 当有数组有一项满足条件时结束并返回true
						}
					})
					if(repeat){
						this.$message.error('源客商重复，请重新选择!');
						return
					}
					newArr = [...this.multipleSelection, ...this.selectList]
					if (this.multipleSelection.length>1&&newArr.length > 10) {
						this.$message.error('只能添加10条源客商!');
						return
					}
				}

				this.$emit("selectRows",this.multipleSelection)
				this.$emit("selectNewFlag", this.newFlag)
				this.dialogVisible = false
			}, 1000, true),
			// 去重
			unRepeat(json1, json2) {
				let json = json1.concat(json2); //两个数组对象合并
				let newJson = []; //盛放去重后数据的新数组
				json.forEach(item1 => {
					let flag = true; //建立标记，判断数据是否重复，true为不重复
					newJson.forEach(item2 => {
						if (item1.agentId == item2.agentId) { //让json数组对象的内容与新数组的内容作比较，相同的话，改变标记为false
							flag = false;
						}
					});
					if (flag) { //判断是否重复
						newJson.push(item1); //不重复的放入新数组。  新数组的内容会继续进行上边的循环。
					}
				});
				return newJson
			},
			// 取消
			cancle() {
				this.dialogVisible = false
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.dialogBox {

		/deep/ .el-dialog__body {
			padding: 0px 10px;
		}

		/deep/ .el-radio .el-radio__label {
			display: none;
		}
	}

	.el-dialog__body {
		height: 500px;
	}

	.el-table {

		// 深度选择器，去除默认的padding
		/deep/ th {
			padding: 5px;
		}

		/deep/ td {
			padding: 5px;
		}

	}

</style>
